import { render, staticRenderFns } from "./DeadServer.vue?vue&type=template&id=6f730126&scoped=true&"
import script from "./DeadServer.vue?vue&type=script&lang=js&"
export * from "./DeadServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f730126",
  null
  
)

export default component.exports